import React from 'react';
import classNames from 'classnames';
import withResizeScreen from 'components/common/with-resize-screen/withResizeScreen';
var comparisonBarChartConfig = {
    defaultMinimumPercentage: 5,
    defaultMaxBarChartPercentage: 30,
    defaultSpaceBetweenBarChartAndText: '0.625rem',
    defaultSpaceBetweenBarChartAndTextMobile: '1px'
};
var ComparisonBarChart = function (props) {
    var _a, _b;
    var defaultMinimumPercentage = comparisonBarChartConfig.defaultMinimumPercentage, defaultMaxBarChartPercentage = comparisonBarChartConfig.defaultMaxBarChartPercentage;
    var value = props.value, maxValue = props.maxValue, backgroundColorClassName = props.backgroundColorClassName, displayTextValue = props.displayTextValue, barChartThickness = props.barChartThickness, _c = props.maxBarChartPercentage, maxBarChartPercentage = _c === void 0 ? defaultMaxBarChartPercentage : _c, windowMode = props.windowMode, _d = props.minimumPercentage, minimumPercentage = _d === void 0 ? defaultMinimumPercentage : _d;
    var maxBarChart = maxBarChartPercentage; // 30% barChart = 50% - 14% display text - 6% padding
    var barChartPercentage = (Math.abs(value) * maxBarChart) / maxValue || 0;
    barChartPercentage = barChartPercentage !== 0 && barChartPercentage < minimumPercentage ? minimumPercentage : barChartPercentage;
    var side = +value > 0 ? 'left' : 'right';
    var spaceBetweenBarChartAndText = windowMode.mobile ? '1px' : '0.625rem';
    return (<div className="c-comparison-bar-chart">
      <div style={_a = { width: "".concat(barChartPercentage, "%"), height: "".concat(barChartThickness, "rem"), position: 'absolute' }, _a[side] = '50%', _a.top = "calc(50% - ".concat(barChartThickness / 2, "rem)"), _a} className={classNames(backgroundColorClassName, 'c-comparison-bar-chart__bar-chart')}/>
      <div style={_b = {}, _b[side] = "calc(".concat(50 + barChartPercentage, "% + ").concat(spaceBetweenBarChartAndText, ")"), _b.position = 'absolute', _b.top = "calc(50% - 0.625rem)", _b} className="c-comparison-bar-chart__display-text">
        {displayTextValue}
      </div>
      <div className="c-comparison-bar-chart__vertical-line"/>
    </div>);
};
export default withResizeScreen(ComparisonBarChart);
